<template>
  <div>
  
    <p v-if="!choice">ERROR: This product option is not properly configured. Please contact us for assistance.</p>
    
    <template v-else>
      <div v-if="choice.price_adjustment" class="builder__step-price-adjust">
        {{ formattedPriceAdjustment }}
      </div>
        
      <div class="builder__step-yes-toggle">
        <input type="checkbox"
          class="builder__step-yes-toggle-input"
          :id="domId"
          :value="choice.id"
          v-model="selected"
          @click="showEmbroideryPopup($event)"
        >
        <label class="builder__step-yes-toggle-label" :for="domId">
          <span class="builder__step-yes-toggle-label-fake-input"></span>
          <span class="builder__step-yes-toggle-label-text">{{ choice.title }}</span>
        </label>
      </div>
    
      <div v-if="option.embroidery_misc_text" class="builder__step-note">
        {{ option.embroidery_misc_text }}
      </div>
      
      <div v-if="option.embroidery_popup_text" :id="popupDomId" class="mfp-hide builder__step-popup">
        {{ option.embroidery_popup_text }}
      </div>
      
      <div v-if="option.embroidery_example_images.length" class="builder__step-example-images">
        <a v-for="img in option.embroidery_example_images" class="builder__step-example-image-link" :href="img.src" @click="showExampleImagesPopup">View Example</a>
      </div>
    </template>
    
  </div>
</template>

<script>
  export default {
    name: 'builder-option-embroidery',
    props: ['option'],
    
    data() {
      return {
        domId: 'product-step-yes-toggle-' + this.option.id,
        popupDomId: 'product-step-embroidery-popup' + this.option.id,
      }
    },
    
    computed: {
      choice() {
        //Some additional info is stored in the option choice
        // (there should be 1 and only 1 of them... if it doesn't exist
        // then something got messed up during dashboard validation, in which case we display an error)
        if (!this.option.choices.length) {
          return null
        } else {
          return this.option.choices[0]
        }
      },
      
      formattedPriceAdjustment() {
        let s = (this.choice.price_adjustment < 0) ? '-' : '+'
        s += ' $'
        s += Math.abs(this.choice.price_adjustment).toFixed(2)
        return s
      },
      
      selected: {
        get() {
          return this.option.selected_value
        },
        set(checked) {
          this.$emit('toggle-embroidery', checked)
          this.$emit('input', (checked ? this.choice.id : null))
        },
      },
    },
    
    methods: {
      showExampleImagesPopup(event) {
        event.preventDefault()
        
        let items = $(event.target).parent().children().map(function() {
          return { src: $(this).attr('href') }
        }).get()
        
        $.magnificPopup.open({
          items: items,
          type: 'image',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
          },
          prependTo: '.js-the-page',
        })
      },
      showEmbroideryPopup(event) {
        if (event.target.checked && $('#' + this.popupDomId).length) {
          $.magnificPopup.open({
            items: {
                src: '#' + this.popupDomId,
              },
            type: 'inline',
            prependTo: '.js-the-page',
          })
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Embroidery.vue?1a6910db